module.exports = __webpack_public_path__ + "static/img/ikonaScenariusz.0aca7349.png";